import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "topbar"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "header-filters",
  gap: 28
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "Brand Portfolio")], -1);
const _hoisted_3 = {
  class: "toolbar"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_button_radio_group = _resolveComponent("app-button-radio-group");
  const _component_brand_portfolio_table = _resolveComponent("brand-portfolio-table");
  const _component_omny_ui_layout = _resolveComponent("omny-ui-layout");
  const _component_app_card_seo = _resolveComponent("app-card-seo");
  return _openBlock(), _createBlock(_component_app_card_seo, {
    loading: $data.dataLoading
  }, {
    default: _withCtx(() => [_createVNode(_component_omny_ui_layout, {
      "content-padding": "0",
      class: "brand-portfolio"
    }, {
      topbar: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_ctx.isOmnyUser ? (_openBlock(), _createBlock(_component_app_button_radio_group, {
        key: 0,
        modelValue: $options.currentAccountType,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.currentAccountType = $event),
        options: $data.accountTypeOptions
      }, null, 8, ["modelValue", "options"])) : _createCommentVNode("", true)])])]),
      default: _withCtx(() => [_createVNode(_component_brand_portfolio_table, {
        ref: "portfolioTable",
        accountType: $data.accountType,
        onRefreshSellersFilter: $options.handleRefreshSellersFilter
      }, null, 8, ["accountType", "onRefreshSellersFilter"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["loading"]);
}